import { ref } from 'vue';

const buildProductOptionsModel = (productData) => {
    const items = productData.productSetItems;
    const result = {
        options: productData.options,
        quantity: productData.quantity,
    };

    if (items) {
        return [result, ...items.map(i => ({
            options: i.setItem.options,
            quantity: i.quantity,
        }))];
    }

    return result;
};

const recalculateItemOptionModifier = (options, quantity) => {
    return options.reduce((sum, curr) => {
        const selectedOption = curr.values.find(e => e.productOptionValueID === curr.productOptionValueID);
        return sum + (selectedOption?.priceModifier || 0) * quantity;
    }, 0);
};

const getProductOptionsModifiersValue = (productData) => {
    const productOptionsModel = buildProductOptionsModel(productData);
    return productOptionsModel.reduce((acc, curr) => {
        return acc + recalculateItemOptionModifier(curr.options, curr.quantity);
    }, 0);
};

export const useProductOptionsModifiers = () => {
    const priceWithOptionModifiers = ref(null);
    const effectivePriceWithOptionModifiers = ref(null);

    const updateProductOptionsModifiersValue = (productData) => {
        const modifiersValue = getProductOptionsModifiersValue(productData);
        priceWithOptionModifiers.value = productData.price + modifiersValue;
        effectivePriceWithOptionModifiers.value = productData.effectivePrice + modifiersValue;
    };

    return {
        priceWithOptionModifiers,
        effectivePriceWithOptionModifiers,
        getProductOptionsModifiersValue,
        updateProductOptionsModifiersValue,
    };
};
